import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Fires a virtual page view on every client-side route change.
 *
 * The first paint is skipped on purpose: the GA4 tag already sends a page_view
 * for the landing URL when gtag.js boots, so counting it here would double it.
 *
 * The small delay lets <SEO />/react-helmet swap document.title first, so the
 * page view carries the new page's title instead of the previous one's.
 */
export default function usePageTracking() {
  const { pathname, search } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const id = window.setTimeout(() => {
      trackPageView({ path: pathname + search });
    }, 250);

    return () => window.clearTimeout(id);
  }, [pathname, search]);
}
